import { Head, Link } from '@inertiajs/react'
import MainLayout from '../../components/layout/MainLayout'
import Button from '../../components/ui/Button'

export default function UnprocessableEntity() {
  return (
    <MainLayout>
      <Head title="Requête invalide - 422" />

      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-yellow-50 to-white px-4 py-20">
        <div className="text-center max-w-2xl">
          {/* Error Icon */}
          <div className="mb-8 inline-block">
            <svg className="w-32 h-32 mx-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Triangle de fond */}
              <path
                d="M12 2L2 20H22L12 2Z"
                fill="#F59E0B"
                fillOpacity="0.1"
              />

              {/* Triangle d'alerte */}
              <path
                d="M12 2L2 20H22L12 2Z"
                stroke="#F59E0B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              {/* Point d'exclamation */}
              <path
                d="M12 8V13"
                stroke="#F59E0B"
                strokeWidth="2.5"
                strokeLinecap="round"
              />
              <circle cx="12" cy="16.5" r="1" fill="#F59E0B"/>
            </svg>
          </div>

          {/* 422 */}
          <h1 className="text-8xl md:text-9xl font-bold text-yellow-600 mb-4">
            422
          </h1>

          {/* Message */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Requête invalide
          </h2>

          <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
            Les données soumises ne sont pas valides. Veuillez vérifier les informations et réessayer.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.history.back()}
              className="px-6 py-3 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors font-medium"
            >
              ← Retour
            </button>
            <Link href="/">
              <Button variant="outline" size="lg">
                Retour à l'accueil
              </Button>
            </Link>
          </div>

          {/* Help Section */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-4">
              Conseils pour résoudre ce problème :
            </p>
            <ul className="text-sm text-gray-500 space-y-2 max-w-md mx-auto text-left">
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Vérifiez que tous les champs obligatoires sont remplis</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Assurez-vous que les formats de données sont corrects</span>
              </li>
              <li className="flex items-start gap-2">
                <svg className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                </svg>
                <span>Actualisez la page et réessayez</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
